module.exports = __webpack_public_path__ + "img/07.51aef8c4.jpg";